import BlueSectionDivider from '../components/BlueSectionDivider';
import IntroSection from '../components/IntroSection';
import JourneySection from '../components/JourneySection';
import OverviewSection from '../components/OverviewSection';
import ProductsSection from '../components/ProductsSection';
import TeamSection from '../components/TeamSection';
import WorkingModelSection from '../components/WorkingModelSection';
import CertificateSection from '../components/CertificateSection';
import CaseStudiesSection from '../components/CaseStudiesSection';
import CustomerTestimonials from '../components/CustomerTestimonials';
import WebflowSection from '../components/WebflowSection';
import TechStackSection from '../components/TechStackSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const AllServices = () => {
  return (
    <div>
      <IntroSection  title ="Seamless digital acceleration that drives competitive advantage" paragraph="Boosting engineering and design capabilities, improving processes, and delivering end-to-end digital products." backgroundImage="/back-image.webp"/>
      <OverviewSection/>
      <JourneySection/>
      <BlueSectionDivider/>
      <TeamSection/>
      <WorkingModelSection/>
      <BlueSectionDivider/>
      <ProductsSection/>
     
      <BlueSectionDivider/>
      <CaseStudiesSection/>
      
      <WebflowSection/>
      <TechStackSection/>
      <ContactSection backgroundColor="#057af0ff"/>
      <Footer/>
      {/* More sections later */}
    </div>
  );
};
export default AllServices;